export default __webpack_public_path__ + "static/media/jobPost.6048dc65.svg";